import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 1rem !important;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 2rem;

  a {
    display: flex;
  }

  svg {
    width: 2.5rem !important;
    height: 2.5rem !important;
  }

  img {
    width: 100% !important;
    height: 3rem !important;
  }
`
